'use client';

import { cn } from '@/libs';

export const Skeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn('animate-skeleton rounded-md bg-foreground/10', className)}
      {...props}
    />
  );
};
